// components/MiceHighlights/HighlightCard.jsx

import React from "react";
import styles from "./HighlightCard.module.css";

// LOGOS
import vivoLogo from "../../../assets/customer brands/vivo.webp";
import pepsiLogo from "../../../assets/customer brands/pepsico.webp";
import oppoLogo from "../../../assets/customer brands/oppo.webp";
import miLogo from "../../../assets/customer brands/MI.webp";
import starHealthLogo from "../../../assets/customer brands/Star.webp";
import scJohnsonLogo from "../../../assets/customer brands/S_C_Johnson.webp";
import amazonLogo from "../../../assets/customer brands/Amazon.webp";
import motorolaSolutionsLogo from "../../../assets/customer brands/Motorola sol.webp";
import reckittLogo from "../../../assets/customer brands/reckitt.webp";
import fybrosLogo from "../../../assets/customer brands/fybros.webp";
import ericssonLogo from "../../../assets/customer brands/Ericsson.webp";
import ozonelogo from "../../../assets/customer brands/ozonelogo.png";




import vivo1a from "./images/vivo vrs (1).webp";
import vivo1b from "./images/vivo vrs (2).webp";
import vivo1c from "./images/vivo vrs (3).webp";
import vivo2a from "./images/vivo dubai feb (1).webp";
import vivo2b from "./images/vivo dubai feb (2).webp";
import vivo3a from "./images/vivo goa (1).webp";
import vivo3b from "./images/vivo goa (2).webp";
import vivo4a from "./images/vivo guwahati (1).webp";
import vivo4b from "./images/vivo guwahati2.jpg";
import vivo5a from "./images/vivo v50 launch event (1).webp";
import vivo5b from "./images/vivo v50 launch event (1).webp";
import vivo6a from "./images/vivo vip night (1).webp";
import vivo6b from "./images/vivo vip night (2).webp";
import vivo7a from "./images/vivo georgia.webp";
import vivo8a from "./images/vivo Istanbul tour.jpeg";

import oppo1a from "./images/oppo.webp";

import mi1a from "./images/MI.webp";

import starhealth1a from "./images/starhealth1.webp";
import starhealth1b from "./images/starhealth2.webp";

import scjohnson1a from "./images/scjohnson.webp";

import amazon1a from "./images/amazon.webp";

import motorolasolution1a from "./images/motodealermeet (1).webp";
import motorolasolution1b from "./images/motodealermeet (2).webp";

import motorolasolution2a from "./images/motohydrabadmeet (1).webp";
import motorolasolution2b from "./images/motohydrabadmeet (2).webp";

// import motorolasolution3a from "./images/motobangloremeet (1).webp";
import motorolasolution3b from "./images/motobangloremeet (2).webp";

import motorolasolution4a from "./images/motoconference (1).webp";
import motorolasolution4b from "./images/motoconference (2).webp";

import reckitt1a from "./images/reckitt lko.webp";
import reckitt1b from "./images/reckitt lucknow (1).webp";
import reckitt2a from "./images/reckitt1.webp";
import reckitt2b from "./images/recktt 2.webp";
import reckitt3a from "./images/reckitt jaipur confe (1).webp";
import reckitt3b from "./images/reckitt jaipur confe (2).webp";
import reckitt4a from "./images/Reckitt-goa cof.webp";

import fybros1a from "./images/fybrps (1).webp";
import fybros1b from "./images/fybrps (2).webp";

import ericsson1a from "./images/ericsson.webp";



import ozone1a from "./images/ozone1.webp";
import ozone1b from "./images/ozone2.webp";




export const clientData = [
  {
  id: "vivo",
  clientName: "Vivo",
  logo: vivoLogo,

  projects: [
      {
      id: 1,
      title: "Vivo VRS Event • 650 Pax",
      description:
        "Large scale Event management • Guest hospitality • Venue operations • On-ground execution",
images: [vivo1a, vivo1b, vivo1c],
    },
        {
      id: 2,
      title: "Vivo Dubai Tour • 30 Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
images: [vivo2a, vivo2b],
    },

    {
      id: 3,
      title: "Vivo Goa Tour • 25 Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
images: [vivo3a, vivo3b],
    },
    
    {
      id: 4,
      title: "Vivo Guwahati Tour • 25 Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
images: [vivo4a, vivo4b],
    },
       {
      id: 5,
      title: "Vivo V50 Launch Event • 250 Pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [vivo5a, vivo5b],
    },

    {
      id: 6,
      title: "Vivo VIP Night Delhi • 650 Pax",
      description:
        "Celebrity Management • On-ground execution",
images: [vivo6a, vivo6b],
    },
        {
      id: 7,
      title: "Vivo Georgia Tour • 110 Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
images: [vivo7a],
    },
   {
      id: 8,
      title: "Vivo Istanbul Tour • 250+ Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
      images: [vivo8a],
    },
    {
      id: 9,
      title: "Vivo Dubai Tour • 170 Pax",
      description:
        "Large scale Travel management • Guest hospitality • On-ground execution",
      images: [],
    },
 
  ],
},

{
  id: "motorolasolutions",
  clientName: "Motorola Solutions",
  logo: motorolaSolutionsLogo,

  projects: [
    {
      id: 1,
      title: "Motorola Solutions Dealers Meet Delhi • 300 Pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [motorolasolution1a, motorolasolution1b],
    },

    {
      id: 2,
      title: "Motorola Solutions Hyderabad Meetings",
      description:
        "Corporate meeting management • Guest coordination • Venue support • On-ground execution",
images: [motorolasolution2a, motorolasolution2b],
    },

    {
      id: 3,
      title: "Motorola Solutions Bangalore Meetings",
      description:
        "Corporate meeting management • Guest coordination • Venue support • On-ground execution",
images: [motorolasolution3b],
    },

    {
      id: 4,
      title: "Motorola Solutions Conference • 300 Pax",
      description:
        "Conference management • Hospitality services • Venue operations • Event execution",
images: [motorolasolution4a, motorolasolution4b],
    },
  ],
},

{
  id: "reckitt",
  clientName: "Reckitt",
  logo: reckittLogo,

  projects: [
        {
      id: 1,
      title: "Reckitt North Conference • The Centrum Lucknow • 170 Pax",
      description:
        "Conference operations • Hospitality services • Venue management • Guest assistance",
images: [reckitt1a, reckitt1b],
    },
    {
      id: 2,
      title: "Reckitt International Conference • ITC WelcomHotel Delhi • 90 Pax",
      description:
        "Conference operations • International guests • Team Building Activity • Guest assistance",
images: [reckitt2a, reckitt2b],
    },
       {
      id: 3,
      title: "Reckitt Marketing Conference Jaipur • 150 Pax",
      description:
        "Marketing conference management • Guest coordination • Venue handling • Event execution",
images: [reckitt3a, reckitt3b],
    },
    {
      id: 4,
      title: "Reckitt Goa Conference",
      description:
        "Conference management • Guest hospitality • Venue operations • On-ground execution",
images: [reckitt4a],
    },

    {
      id: 5,
      title: "Reckitt EXLT Meet • Oberoi Gurgaon • 150 Pax",
      description:
        "Executive event management • Hospitality services • Venue coordination • Guest handling",
      images: [],
    },

    {
      id: 6,
      title: "Reckitt Leadership Conference • Leela Delhi • 250 Pax",
      description:
        "Leadership conference management • Guest hospitality • Venue operations • Event execution",
      images: [],
    },
    {
      id: 7,
      title: "Reckitt Conference Hyderabad • Le Meridien • 200 Pax",
      description:
        "Conference operations • Hospitality services • Venue management • Guest assistance",
      images: [],
    },
    {
      id: 8,
      title: "Reckitt Delhi Event • Westin Sohna • 220 Pax",
      description:
        "Corporate event management • Hospitality services • Venue support • On-ground execution",
      images: [],
    },

 
  ],
},

  {
    id: "pepsico",
    clientName: "PepsiCo",
    logo: pepsiLogo,
    projects: [
      {
        id: 1,
        title: "Hongkong Tour 100pax 2019",
      description:
  "Large scale Travel management • Guest hospitality • On-ground execution",
     images: [],
      },
    ],
  },
  {
  id: "oppo",
  clientName: "OPPO",
  logo: oppoLogo,
  projects: [
    {
      id: 1,
      title: "OPPO Jaipur eveent 150 pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [oppo1a],
    },
  ],
},

{
  id: "mi",
  clientName: "Mi",
  logo: miLogo,
  projects: [
    {
      id: 1,
      title: "Mi Dealers Event",
      description:
        " 150 pax • Guest hospitality • Venue operations • On-ground execution",
images: [mi1a],
    },
  ],
},

{
  id: "starhealth",
  clientName: "Star Health",
  logo: starHealthLogo,
  projects: [
    {
      id: 1,
      title: "Star Health Event Jim Corbett 150 Pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [starhealth1a, starhealth1b],
    },
  ],
},

{
  id: "scjohnson",
  clientName: "SC Johnson",
  logo: scJohnsonLogo,
  projects: [
    {
      id: 1,
      title: "SC Johnson RNR Event 2019",
      description:
        "THE LEELA AMBIENCE DELHI • Guest hospitality • 150 PAX • On-ground execution",
images: [scjohnson1a],
    },
  ],
},

{
  id: "amazon",
  clientName: "Amazon",
  logo: amazonLogo,
  projects: [
    {
      id: 1,
      title: "Amazon Day outing meeting - 120 pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [amazon1a],
    },
  ],
},


{
  id: "fybros",
  clientName: "Fybros",
  logo: fybrosLogo,
  projects: [
    {
      id: 1,
      title: "Fybros Event Chandigarh 140 pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [fybros1a, fybros1b],
    },
  ],
},

{
  id: "ericsson",
  clientName: "Ericsson",
  logo: ericssonLogo,
  projects: [
    {
      id: 1,
      title: "Ericsson Regular OBTS events - 1000 pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [ericsson1a],    },
  ],
},
{
  id: "ozone pharma",
  clientName: "Ozone Pharma",
  logo: ozonelogo,
  projects: [
    {
      id: 1,
      title: "Doctor's Meet and Dinner - 90 pax",
      description:
        "Large scale event management • Guest hospitality • Venue operations • On-ground execution",
images: [ozone1a ,ozone1b],    },
  ],
},
];

function HighlightCard({ item, onClick }) {
  return (
    <div
      className={styles.card}
      onClick={() => {
        console.log("clicked");
        onClick(item);
      }}
    >
      <div className={styles.logoWrapper}>
        <img
          src={item.logo}
          alt={item.clientName}
          className={styles.logo}
        />
      </div>

      <div className={styles.text}>
        {/* <span>{item.clientName}</span> */}

        <span className={styles.x}>X</span>

        <span>Event by ATLAS</span>
      </div>
    </div>
  );
}

export default HighlightCard;